import { MJESECI } from './constants';

export const parseTimestamp = (timestamp) => {
  let date = timestamp.split('T')[0];
  let dateSplit = date.split('-');
  date = [
    parseInt(dateSplit[2]) + '.', 
    MJESECI[parseInt(dateSplit[1] - 1)], // array offset 
    dateSplit[0]].join(' ').concat('.');

  let time = timestamp.split('T')[1];
  let timeSplit = time.split(':');
  time = [timeSplit[0], timeSplit[1]].join(':');

  return [date, time]
}